import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { 
  fetchAllFeedbacks, 
  createFeedback, 
  updateFeedback, 
  deleteFeedback 
} from '../utils/feedbackApi';

const FeedbackManagement = () => {
  const { token } = useAuth();
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ Name: '', Comment: '', Rating: 5, Active: true });

  const loadFeedbacks = async () => {
    try {
      setLoading(true);
      const data = await fetchAllFeedbacks(token);
      setFeedbacks(data);
    } catch (err) {
      console.error('Error loading feedbacks:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) loadFeedbacks();
  }, [token]);

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const payload = {
      Name: formData.Name,
      Comment: formData.Comment,
      Rating: parseInt(formData.Rating, 10),
      Active: Boolean(formData.Active),
    };

    await createFeedback(payload, token);
    setFormData({ Name: '', Comment: '', Rating: 5, Active: true });
    loadFeedbacks();
  } catch (err) {
    console.error('Failed to create feedback:', err);
  }
};

  const toggleActive = async (id, currentStatus) => {
    try {
      const updated = await updateFeedback(id, { Active: !currentStatus }, token);
      setFeedbacks(feedbacks.map(f => f.id === id ? updated : f));
    } catch (err) {
      console.error('Failed to update status:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze review wilt verwijderen?')) return;
    try {
      await deleteFeedback(id, token);
      setFeedbacks(feedbacks.filter(f => f.id !== id));
    } catch (err) {
      console.error('Failed to delete feedback:', err);
    }
  };

  if (loading) return <div className="admin-page"><p style={{ color: '#00d9ff' }}>Laden...</p></div>;

  return (
    <div className="admin-page">
      <h1>Feedback Beheer</h1>

      <form className="admin-form" onSubmit={handleSubmit}>
        <h3>Nieuwe Review Toevoegen</h3>
        <div className="form-group">
          <label>Naam Client</label>
          <input 
            type="text" 
            className="form-control"
            value={formData.Name} 
            onChange={(e) => setFormData({...formData, Name: e.target.value})} 
            required 
          />
        </div>
        <div className="form-group">
          <label>Beoordeling (1-5)</label>
          <select 
            className="form-control"
            value={formData.Rating} 
            onChange={(e) => setFormData({...formData, Rating: e.target.value})}
          >
            {[5, 4, 3, 2, 1].map(num => <option key={num} value={num}>{num} Sterren</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Feedback / Review</label>
          <textarea 
            className="form-control"
            rows="3"
            value={formData.Comment} 
            onChange={(e) => setFormData({...formData, Comment: e.target.value})} 
            required 
          />
        </div>
        <button type="submit" className="btn-primary">Review Toevoegen</button>
      </form>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Klant</th>
            <th>Rating</th>
            <th>Status</th>
            <th>Acties</th>
          </tr>
        </thead>
        <tbody>
          {feedbacks.map((f) => (
            <tr key={f.id}>
              <td>{f.Name}</td>
              <td>{'★'.repeat(f.Rating || 5)}</td>
              <td>
                <span className={`status-badge ${f.Active ? 'active' : 'inactive'}`}>
                  {f.Active ? 'Zichtbaar' : 'Verborgen'}
                </span>
              </td>
              <td className="table-actions">
                <button className="btn-action" onClick={() => toggleActive(f.id, f.Active)}>
                  {f.Active ? 'Verbergen' : 'Tonen'}
                </button>
                <button className="btn-action delete" onClick={() => handleDelete(f.id)}>
                  Verwijderen
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FeedbackManagement;